import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link, useLocation } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL;
const LoginPage = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(t(data.messageKey) || t('login_failed'));
      }
      login(data.user, data.token);

      const from = location.state?.from?.pathname || '/';
      if (from !== '/') {
        navigate(from, { replace: true });
        return;
      }
      
      const userRole = data.user.role;
      if (userRole === 'admin' || userRole === 'support') {
        navigate('/management/all-jobs', { replace: true });
      } else if (userRole === 'translator') {
        navigate('/dashboard/jobs', { replace: true });
      } else {
        navigate('/account/orders', { replace: true });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-form-card">
        <h2 className="auth-title">{t('login_title')}</h2>
        
        {/* DÜZELTME: <LoginForm> yerine doğrudan <form> etiketi kullanılıyor */}
        <form onSubmit={handleSubmit}>
          <div className="form-group-auth floating-label">
            <input 
              id="login-email" 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
              placeholder=" "
            />
            <label htmlFor="login-email">{t('email_address')}</label>
          </div>
          <div className="form-group-auth floating-label">
            <input 
              id="login-password" 
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
              placeholder=" "
            />
            <label htmlFor="login-password">{t('password')}</label>
          </div>
          {error && <p className="auth-error">{error}</p>}
          <div className="form-options">
            <label className="auth-checkbox">
              <input type="checkbox" /> <span>{t('remember_me')}</span>
            </label>
            <Link to="/forgot-password" className="auth-link">{t('forgot_password')}</Link>
          </div>
          <button type="submit" className="auth-submit-btn" disabled={isLoading}>
            {isLoading ? t('logging_in') : t('login_button')}
          </button>
        </form>

        <p className="auth-redirect">
          {t('no_account_yet')} <Link to="/register" className="auth-link">{t('register_now')}</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;